export enum RequiringActionType {
  SUBMIT = 'SUBMIT',
  SUBMIT_CLAIM = 'SUBMIT_CLAIM',
  UPDATE = 'UPDATE',
  REVIEW = 'REVIEW',
  PAY = 'PAY',
  SIGN = 'SIGN',
  JOIN = 'JOIN',
  SECURE = 'SECURE',
  'REQUEST APPROVED' = 'REQUEST APPROVED',
  'REQUEST REJECTED' = 'REQUEST REJECTED',
  'SUBMIT REPORT' = 'SUBMIT REPORT',
  'REVIEW REPORT' = 'REVIEW REPORT',
}

export enum RequiringActionStatus {
  PENDING = 'PENDING',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  COMPLETED = 'COMPLETED',
}

export enum RequiringActionFeatureType {
  CONTRACT = 'CONTRACT',
  JOIN_CONTRACT = 'JOIN_CONTRACT',
  CONTRACT_DEPOSIT = 'CONTRACT_DEPOSIT',
  VARIATION = 'VARIATION',
  ADJUSTMENT = 'ADJUSTMENT',
  CLAIM = 'CLAIM',
  EARLY_RELEASE_REQUEST = 'EARLY_RELEASE_REQUEST',
  SECURE_PAID_REQUEST = 'SECURE_PAID_REQUEST',
  UNSECURE_PAID_REQUEST = 'UNSECURE_PAID_REQUEST',
  REFUND_REQUEST = 'REFUND_REQUEST',
  TERMINATE_CONTRACT_REQUEST = 'TERMINATE_CONTRACT_REQUEST',
  ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST = 'ACCEPT_ACCESS_LINKED_CONTRACTS_REQUEST',
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
  CLAIM_ASSESSMENT_REQUEST = 'CLAIM_ASSESSMENT_REQUEST',
  CLAIM_ASSESSMENT_REPORT = 'CLAIM_ASSESSMENT_REPORT',
  REVIEW_CLAIM_DOCUMENTS = 'REVIEW_CLAIM_DOCUMENTS',
  MASTER_CONTRACT_PDF = 'MASTER_CONTRACT_PDF',
  ASSOCIATE_RECKONER_REQUEST = 'ASSOCIATE_RECKONER_REQUEST',
  RETENTION_REQUEST = 'RETENTION_REQUEST',
}

export enum ContractAction {
  CONTRACT_REVIEW = 'CONTRACT_REVIEW',
  CONTRACT_AMEND = 'CONTRACT_AMEND',
  CONTRACT_SIGN = 'CONTRACT_SIGN',
  CLAIM_SUBMIT = 'CLAIM_SUBMIT',
  /** @deprecated */
  CLAIM_REVIEW = 'CLAIM_REVIEW',
  CLAIM_EDIT = 'CLAIM_EDIT',
  CLAIM_ASSESS = 'CLAIM_ASSESS',
  VARIATION_SUBMIT = 'VARIATION_SUBMIT',
  VARIATION_REVIEW = 'VARIATION_REVIEW',
  CLAIM_PAY = 'CLAIM_PAY',
  CLAIM_APPROVE = 'CLAIM_APPROVE',
  CLAIM_ASSESSMENT_REQUEST_SUBMIT = 'CLAIM_ASSESSMENT_REQUEST_SUBMIT',
  CLAIM_ASSESSMENT_REPORT_SUBMIT = 'CLAIM_ASSESSMENT_REPORT_SUBMIT',
  RETENTION_REQUEST_UNRETAIN_SUBMIT = 'RETENTION_REQUEST_UNRETAIN_SUBMIT',
}
